/**
 * What an invoice is for.
 *
 * The admin fees screen raises fee invoices and sets this value itself rather
 * than asking. The enum exists so other kinds can be added — the invoice a
 * business raises to its own customer, for instance — without every consumer
 * having to guess what an untyped invoice represents.
 */
export var BusinessInvoiceType;
(function (BusinessInvoiceType) {
    BusinessInvoiceType["BusinessFeeInvoice"] = "BUSINESS_FEE_INVOICE";
    BusinessInvoiceType["BusinessCustomerInvoice"] = "BUSINESS_CUSTOMER_INVOICE";
})(BusinessInvoiceType || (BusinessInvoiceType = {}));
//# sourceMappingURL=BusinessInvoiceType.js.map